import { AppPlatform, AppleAppStorePhasedReleaseState, GooglePlayStoreState, PhasedRelease } from '@/types';

export const mockPhasedReleaseForPlatform: (platform: AppPlatform, releasedAt: string) => PhasedRelease = (
    platform,
    releasedAt,
) => {
    switch (platform) {
        case AppPlatform.Android:
            return {
                state: GooglePlayStoreState.InProgress,
                phasedReleasePercent: 2,
                startDate: releasedAt,
                dayNumber: 2,
                userFraction: 0.02,
                isRunwayAcceleratedRollout: false,
                isRunwayPaused: false,
                isManuallyAcceleratedPhasedRollout: false,
                isOnBlackoutPeriod: false,
                isSuperseded: false,
            };
        case AppPlatform.Ios:
            return {
                state: AppleAppStorePhasedReleaseState.Active,
                phasedReleasePercent: 5,
                startDate: releasedAt,
                dayNumber: 2,
                userFraction: 0.02,
                isRunwayAcceleratedRollout: false,
                isRunwayPaused: false,
                isManuallyAcceleratedPhasedRollout: false,
                isOnBlackoutPeriod: false,
                isSuperseded: false,
            };
        default:
            return null;
    }
};
